import { render, staticRenderFns } from "./FlagDialog.vue?vue&type=template&id=5d2be588&"
import script from "./FlagDialog.vue?vue&type=script&lang=js&"
export * from "./FlagDialog.vue?vue&type=script&lang=js&"
import style0 from "./FlagDialog.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FlagDialog.vue"
export default component.exports